import { FC } from 'react'
import './OrdersPlaceholder.scss'

const OrdersPlaceholder: FC = () => (
  <div className="OrdersPlaceholderWrapper">No orders to display</div>
)

export default OrdersPlaceholder
